import React, { useEffect } from "react";
import "./App.css";
import Main from "./screens";
import { useAppDispatch } from "./redux";
import { updateData } from "./redux/actions";
import { UPDATE_INTERVAL } from "./utils/consts";

// import smartquotes from "smartquotes";
// useEffect(() => {
//   smartquotes().listen();
// }, []);

const App: React.FC = () => {
  const dispatch = useAppDispatch();

  // update data every UPDATE_INTERVAL minutes
  // TODO this runs twice for some reason?
  useEffect(() => {
    // initial data fetch
    dispatch(updateData());

    // update data at an interval
    const interval = setInterval(() => {
      dispatch(updateData());
    }, UPDATE_INTERVAL * 60 * 1000);

    // cleanup function
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Main />;
};

export default App;
